import { generateAutomationName } from "../../../helpers/generateAutomationName";

export const unsavedModalKeys = {
    title: generateAutomationName("settings", ["cancelModal", "title"]),
    btnContainer: generateAutomationName("settings", ["cancelModal", "buttons", "container"]),
};
